"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneratedScriptToJSON = exports.GeneratedScriptFromJSONTyped = exports.GeneratedScriptFromJSON = exports.instanceOfGeneratedScript = void 0;
/**
 * Check if a given object implements the GeneratedScript interface.
 */
function instanceOfGeneratedScript(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "script" in value;
    return isInstance;
}
exports.instanceOfGeneratedScript = instanceOfGeneratedScript;
function GeneratedScriptFromJSON(json) {
    return GeneratedScriptFromJSONTyped(json, false);
}
exports.GeneratedScriptFromJSON = GeneratedScriptFromJSON;
function GeneratedScriptFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'script': json['script'],
    };
}
exports.GeneratedScriptFromJSONTyped = GeneratedScriptFromJSONTyped;
function GeneratedScriptToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'script': value.script,
    };
}
exports.GeneratedScriptToJSON = GeneratedScriptToJSON;
